/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import Glide from '@glidejs/glide';

import { markElementReady } from '@root/src/framework/scripts/helpers/element-ready';
import { type App } from '~/app';

import JsController from '../../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'campaign-hero-banner');
    controller.addMountFunction(() => {
        mountComponent(controller);
    })

    return controller.init();
}

export function mountComponent( controller: JsController ) {
    let originalWindowWidth= window.innerWidth;
    const elements = document.querySelectorAll<HTMLElement>('.campaign-banner-carousel');

    // Loop through and individually instantiate each Glide instance
    const initialiseCampaignHeroBannerCarousel = (elements: NodeListOf<HTMLElement>) => {
        for (const element of elements) {
            const glide = new Glide(element, {
                type:'carousel',
                perView: 1,
                gap:0,
                autoplay:5000,
            });
            
            glide.mount();

            markElementReady(element);
        }
    };

    
    if(elements && elements.length > 0)
        initialiseCampaignHeroBannerCarousel(elements);

    const reinitialiseCarousel = () => {
        if(originalWindowWidth!=window.innerWidth){
            originalWindowWidth = window.innerWidth;
            initialiseCampaignHeroBannerCarousel(elements);
        }
    };

    // On screensize re-initialise the carousel to handle per view updates on different screensizes
    controller.addListener(window,'resize', reinitialiseCarousel);
}
